module.exports = __webpack_public_path__ + "img/2x UHF-DVS-50 & 3x BS-PD.d0d7c488.svg";